module.exports = __webpack_public_path__ + "static/case-orangina-addce3ef7aee2db80ee9fd90cefc7d11.mp4";